export interface BatchStatisticsDailyOutputRequest {
  outputDate: string
  batchType: string
}

export function BatchStatisticsDailyOutputRequestToJSON(
  value: BatchStatisticsDailyOutputRequest
): any {
  return {
    output_date: value.outputDate,
    batch_type: value.batchType
  }
}
